<template>
    <!-- Pills Filter -->
    <template v-if="locations.length < 11">
        <ul :class="[config.navPillsClass, config.pillsVisibilityClass]"
            class="nav nav-pills nav-emp justify-content-center align-items-center mb-3"
            role="tablist">

            <li v-for="location in locations" class="nav-item" role="presentation">
                <a :class="[ activeLocation && (location.id === activeLocation.id) ? 'active' : '', config.navLinkClass]"
                   class="nav-link"
                   type="button"
                   @click.prevent="activeLocation = location">
                    {{ location.name }}
                </a>
            </li>
        </ul>
    </template>

    <div :class="[
             config.navDropdownClass,
             config.dropdownVisibilityClass ? config.dropdownVisibilityClass : (locations.length >= 11 ? 'd-flex' : 'd-flex d-lg-none')
             ]"
         class="dropdown nav-emp justify-content-center my-3"
    >
        <button :class="'btn-' + config.dropdownClass"
                aria-expanded="false"
                class="btn dropdown-toggle"
                data-bs-toggle="dropdown"
                type="button"
        >
            {{ activeLocation ? activeLocation.name : 'Bitte wählen' }}
        </button>
        <ul class="dropdown-menu">
            <li v-for="location in locations">
                <a class="dropdown-item"
                   @click.prevent="activeLocation = location"
                >
                    {{ location.name }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>

import {inject, onMounted} from "vue";
import type EmployeeProvider from "../EmployeeProvider.ts";

interface Props {
    config: Object
}

const {
    config
} = defineProps<Props>();

const employeeProvider = inject<EmployeeProvider>("employeeProvider") as EmployeeProvider;

const locations = employeeProvider.getLocations();

const activeLocation = employeeProvider.getActiveLocationRef();

onMounted(() => {
    // when component is loaded, set active location
    if (activeLocation.value === undefined) {
        activeLocation.value = locations[0];
    }
});

</script>
